import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import AuthLoader from '../../Components/Helper/AuthLoader';
import { setUserFromLocalStorage } from '../../Store/userSlice';
import { isSuperAdmin } from '../../utils/roleUtils';
import { useDemoView } from '../../contexts/DemoViewContext';

const SuperAdminCheck = ({ element }) => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);
  const { demoView } = useDemoView();

  useEffect(() => {
    // If no user in Redux, try to load from localStorage
    if (!user || !user.email) {
      dispatch(setUserFromLocalStorage());
    }
    setIsLoaded(true);
  }, [dispatch, user]);

  // Show loading while checking authentication
  if (!isLoaded) {
    return <AuthLoader />;
  }

  // Check if user is logged in
  if (!user || !user.email) {
    return <Navigate to="/teacher-login" replace />;
  }

  // Check if user is a super admin using centralized role utility
  if (!isSuperAdmin(user)) {
    return <Navigate to="/myprofile" replace />;
  }

  // Demo View is ON — the super admin has explicitly chosen to mirror a
  // teacher's experience. Bounce any super-admin-only route back to the
  // teacher dashboard so admin chrome can't surface mid-demo.
  if (demoView) {
    return <Navigate to="/myprofile" replace />;
  }

  // User is authenticated and is a super admin
  return element;
};

SuperAdminCheck.propTypes = {
  element: PropTypes.node.isRequired,
};

export default SuperAdminCheck;
